import { faFilter } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "components/card/Card";
import Checkbox from "components/form/checkbox/Checkbox";
import Popover from "components/popover/Popover";
import Spin from "components/spin/spin";
import { useAppSelector } from "hooks/redux";
import useOutsideAlerter from "hooks/useOutsideAlerter/useOutsideAlerter";
import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { ITeeTimeNew } from "redux/reducers/models/teetime";
import { useDashboardContext } from "../../DashboardContext";
import PlayerBookingGraph from "./PlayerBookingGraph";
import "./playerVolume.scss";

interface IProps {
  teetimes: Array<ITeeTimeNew>;
}

export default function PlayerVolume(props: IProps) {
  const { teetimes } = props;
  const { t } = useTranslation();
  const { selectedCourseIds, setSelectedCourseIds, setSelectedDivisionIds } = useDashboardContext();
  const [filterActive, setFilterActive] = useState(false);
  const { facilityStore } = useAppSelector(store => store);
  const filterRef = useRef(null);
  useOutsideAlerter(filterRef, () => setFilterActive(false));

  function handleCourseChange(courseId: number) {
    let updatedCourseIds = [...selectedCourseIds];
    if (updatedCourseIds.includes(courseId)) {
      updatedCourseIds = updatedCourseIds?.filter(course => course !== courseId);
    } else {
      updatedCourseIds.push(courseId);
    }
    const courseOrder = facilityStore?.facility?.courses?.map(course => course.id) || [];
    //Keep selected course ids in same order as in facilityStore
    updatedCourseIds.sort((a, b) => courseOrder.indexOf(a) - courseOrder.indexOf(b));
    //Get all division ids from the selected courses
    const updatedDivisionIds = facilityStore?.facility?.courses
      ?.filter(course => updatedCourseIds.includes(course?.id))
      ?.map(course => course?.divisions?.map(division => division?.id))
      ?.reduce((a, b) => a.concat(b, []), []);
    ReactDOM.unstable_batchedUpdates(() => {
      setSelectedCourseIds(updatedCourseIds);
      setSelectedDivisionIds(updatedDivisionIds);
    });
  }

  return (
    <Card
      title={t("Player Volume")}
      titleDetails={
        facilityStore?.facility?.courses?.length > 1
          ? [
              {
                content: (
                  <div ref={filterRef} className="relative cursor-pointer">
                    <FontAwesomeIcon onClick={() => setFilterActive(prev => !prev)} icon={faFilter} />
                    <Popover position="right" active={filterActive}>
                      <div>
                        {facilityStore?.facility?.courses?.map((course, index) => {
                          return (
                            <div
                              key={index}
                              className="ui-player-volume-filter"
                              onClick={() => handleCourseChange(course?.id)}
                            >
                              <div className="pointer-events-none">
                                <Checkbox
                                  size="small"
                                  labelHidden
                                  checked={selectedCourseIds?.includes(course?.id)}
                                  onChange={() => handleCourseChange(course?.id)}
                                />
                              </div>
                              <p>{course?.long_name}</p>
                            </div>
                          );
                        })}
                      </div>
                    </Popover>
                  </div>
                ),
              },
            ]
          : undefined
      }
    >
      <Card.Section>
        {!teetimes ? (
          <div style={{ height: "40px", display: "flex", width: "40px", margin: "auto" }}>
            <Spin />
          </div>
        ) : (
          <PlayerBookingGraph teetimes={teetimes} courseIds={selectedCourseIds} />
        )}
      </Card.Section>
    </Card>
  );
}
